<h2 mat-dialog-title>Tierart für {{ material.bezeichnung }}</h2>
<mat-dialog-content>
    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_1_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_1_9_'">Tierart</mat-label>
        <mat-select
            [compareWith]="tierartComparator"
            [formControl]="tierartCtrl"
            [attr.data-cy]="'atattadattad_mat-select_1_6_'"
        >
            <mat-option
                *ngFor="let t of tierarten; let i = index"
                [value]="t"
                [attr.data-cy]="'atattadattad_mat-option_1_7_' + i"
                >{{ t.tierart }}</mat-option
            >
        </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_2_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_2_9_'">Menge</mat-label>
        <input type="number" matInput [(ngModel)]="artikelTierart.menge" [attr.data-cy]="'atattadattad_input_1_1_'" />
    </mat-form-field>

    <kiene-einheit-selector [preselected]="einheit" (changed)="setEinheit($event)"></kiene-einheit-selector>

    <!-- <mat-form-field style="width: 100%;" [attr.data-cy]="'atattadattad_mat-form-field_3_8_'">
    <mat-label [attr.data-cy]="'atattadattad_mat-label_3_9_'">Wartezeit Fleisch</mat-label>
    <input type="number" matInput [(ngModel)]="artikelTierart.wartezeit_tage" [attr.data-cy]="'atattadattad_input_2_1_'">
  </mat-form-field>

  <mat-form-field style="width: 100%;" [attr.data-cy]="'atattadattad_mat-form-field_4_8_'">
    <mat-label [attr.data-cy]="'atattadattad_mat-label_4_9_'">Wartezeit Milch</mat-label>
    <input type="number" matInput [(ngModel)]="artikelTierart.wartezeit_milch" [attr.data-cy]="'atattadattad_input_3_1_'">
  </mat-form-field>

  <mat-form-field style="width: 100%;" [attr.data-cy]="'atattadattad_mat-form-field_5_8_'">
    <mat-label [attr.data-cy]="'atattadattad_mat-label_5_9_'">Wartezeit Eier</mat-label>
    <input type="number" matInput [(ngModel)]="artikelTierart.wartezeit_eier" [attr.data-cy]="'atattadattad_input_4_1_'">
  </mat-form-field> -->

    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_6_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_6_9_'">Behandlung in Tagen</mat-label>
        <input
            type="number"
            matInput
            [(ngModel)]="artikelTierart.behandlung_tage"
            [attr.data-cy]="'atattadattad_input_5_1_'"
        />
    </mat-form-field>
    
    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_6_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_6_9_'">Behandlung in Tagen (Text)</mat-label>
        <input
            type="text"
            matInput
            placeholder=""
            [(ngModel)]="artikelTierart.behandlung_tage_txt"
            [attr.data-cy]="'atattadattad_input_6_1_'"
        />    
    </mat-form-field>

    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_7_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_7_9_'">Intervall in Stunden</mat-label>
        <input
            type="number"
            matInput
            [(ngModel)]="artikelTierart.intervall_std"
            [attr.data-cy]="'atattadattad_input_6_1_'"
        />
    </mat-form-field>

    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_8_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_8_9_'">Faktor</mat-label>
        <input type="number" matInput [(ngModel)]="artikelTierart.faktor" [attr.data-cy]="'atattadattad_input_7_1_'" />
    </mat-form-field>

    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_9_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_9_9_'">Körpergewicht in KG</mat-label>
        <input
            type="number"
            matInput
            placeholder=""
            [(ngModel)]="artikelTierart.koerpergewicht"
            [attr.data-cy]="'atattadattad_input_8_1_'"
        />
    </mat-form-field>

    <mat-form-field style="width: 100%" [attr.data-cy]="'atattadattad_mat-form-field_10_8_'">
        <mat-label [attr.data-cy]="'atattadattad_mat-label_10_9_'">Dosierungstext</mat-label>
        <input
            type="text"
            matInput
            placeholder=""
            [(ngModel)]="artikelTierart.dosierung_txt"
            [attr.data-cy]="'atattadattad_input_9_1_'"
        />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="cancel()" [attr.data-cy]="'atattadattad_button_1_0_'">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="save()" [attr.data-cy]="'atattadattad_button_2_0_'">
        Speichern
    </button>
</mat-dialog-actions>
